import { random, sample } from 'lodash';
import { paramCase } from 'change-case';
// utils
import mock from './mock';
import mockData from '../utils/mock-data';

// ----------------------------------------------------------------------

const PRODUCT_NAME = [
  'JI-701-0385',
  'JI-701-0475',
  'JI-701-0171',
  'JI-701-0473',
  'JI-701-0472',
  'JI-701-0477',
  'JI-701-0470',
  'JI-701-0474',
  'JI-701-0476',
  'JI-701-0479',
  'JI-701-0478',
  'JI-701-0415',
  'JI-701-0411',
  'JI-701-0412',
  'JI-701-0413',
  'JI-701-0414',
  'JI-701-0415',
  'JI-701-0416',
  'JI-701-0417',
  'JI-701-0418',
  'JI-701-0419',
  'JI-701-0420',
  'JI-701-0421',
  'JI-701-0422',
  'JI-701-0423'
];

const KPKNL_NAME = [
  'KPKNL Jakarta I - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Madiun - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Surabaya - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Batam - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Kendari - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Bogor - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jakarta I - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Madiun - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Surabaya - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Batam - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Kendari - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Bogor - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jakarta I - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Madiun - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Surabaya - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Batam - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Kendari - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Bogor - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114',
  'KPKNL Jayapura - Jl. Made Sabara No. 6 Kendari 93114'
];
const TGLELANG_NAME = [
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00',
  '02-12-2021 10:00'
];

const TELP_NAME = [
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369',
  '+62401-3128369'
];

const location = [
  'Depok, Jawa Barat',
  'Cileungsi, Jawa Barat',
  'Depok, Jawa Barat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Palmerah, Jakarta Barat',
  'Palmerah, Jakarta Barat',
  'Palmerah, Jakarta Barat',
  'Slipi, Jakarta Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara'
];

export const tglLelang = [
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021'
];

const tipe = [
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement'
];
const PRODUCT_DETAIL = [
  '1.993.200.000',
  '1.593.200.000',
  '1.093.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000'
];

const PRODUCT_DETAIL2 = [
  '2.993.200.000',
  '2.593.200.000',
  '2.093.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000'
];
const PRODUCT_COLOR = ['#00AB55', '#000000', '#FFFFFF', '#FFC0CB', '#FF4842', '#1890FF', '#94D82D', '#FFC107'];

const PRODUCT_TAGS = ['Dangal', 'The Sting', '2001: A Space Odyssey', "Singin' in the Rain"];

const PRODUCT_DESCRIPTION = `
<p><strong><small> SPECIFICATION</small></strong></p>
<p>Leather panels. Laces. Rounded toe. Rubber sole.
<br /><br />
<p><strong><small> MATERIAL AND WASHING INSTRUCTIONS</small></strong></p>
<p>Shoeupper: 54% bovine leather,46% polyurethane. Lining: 65% polyester,35% cotton. Insole: 100% polyurethane. Sole: 100% thermoplastic. Fixing sole: 100% glued.</p>
`;
const PRODUCT_SIZE = ['6', '7', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '13'];

// ----------------------------------------------------------------------

const products = [...Array(24)].map((_, index) => ({
  id: mockData.id(index),
  cover: mockData.image.products(index),
  images: [...Array(8)].map((_, index) => mockData.image.products(index)),
  name: PRODUCT_NAME[index],
  detail: PRODUCT_DETAIL[index],
  tglLelang: tglLelang[index],
  detail2: PRODUCT_DETAIL2[index],
  KPKNL_NAME: KPKNL_NAME[index],
  TGLELANG_NAME: TGLELANG_NAME[index],
  TELP_NAME: TELP_NAME[index],
  location: location[index],
  tipe: tipe[index],
  code: `38BEE27${index}`,
  sku: `WW75K521${index}YW/SV`,
  tags: PRODUCT_TAGS,
  price: mockData.number.price(index),
  priceSale: index % 3 ? null : mockData.number.price(index),
  totalRating: mockData.number.rating(index),
  totalReview: random(9999),
  ratings: [...Array(5)].map((_, index) => ({
    name: `${index + 1} Star`,
    starCount: random(9999),
    reviewCount: random(9999)
  })),
  reviews: [...Array(8)].map((_, index) => ({
    id: mockData.id(index),
    name: mockData.name.fullName(index),
    avatarUrl: `/static/mock-images/avatars/avatar_${index + 1}.jpg`,
    comment: mockData.text.sentence(index),
    rating: mockData.number.rating(index),
    isPurchased: mockData.boolean(index),
    helpful: random(9999),
    postedAt: mockData.time(index)
  })),
  colors:
    (index === 1 && PRODUCT_COLOR.slice(0, 2)) ||
    (index === 2 && PRODUCT_COLOR.slice(1, 3)) ||
    (index === 3 && PRODUCT_COLOR.slice(2, 4)) ||
    (index === 4 && PRODUCT_COLOR.slice(3, 6)) ||
    (index === 23 && PRODUCT_COLOR.slice(4, 6)) ||
    (index === 24 && PRODUCT_COLOR.slice(5, 6)) ||
    PRODUCT_COLOR,
  status: index % 3 ? sample(['new', '', '', '', '', '']) : 'sale',
  inventoryType: sample(['in_stock', 'out_of_stock', 'low_stock']),
  sizes: PRODUCT_SIZE,
  available: index % 3 === 0 ? random(19, 100) : 2,
  description: PRODUCT_DESCRIPTION,
  sold: random(999),
  createdAt: mockData.time(index),
  category: sample(['Shose', 'Apparel', 'Accessories']),
  gender: sample(['Men', 'Women', 'Kids'])
}));

// ----------------------------------------------------------------------

mock.onGet('/api/products').reply(200, { products });

// ----------------------------------------------------------------------

mock.onGet('/api/products/product').reply((config) => {
  try {
    const { name } = config.params;
    console.log('Nama ');
    console.log(JSON.stringify(products));
    const product = products.find((_product) => paramCase(_product.name) === name);

    if (!product) {
      return [404, { message: 'product not found' }];
    }

    return [200, { product }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});
